import React from 'react';
import { connect } from 'react-redux';
import {
  Avatar,
  Button,
  Collapse,
  Form,
  Icon,
  Input,
  message,
  Row,
  Skeleton,
  Spin,
  Upload,
} from 'antd';
import { ComponentText } from '../../shared/ComponentText';
import { prepareInput } from '../../../utils/InputFieldCongifurations';
import { InputComponent } from '../../shared/FormComponent/InputComponent';
import Space from '../../shared/Spcae';
import { ComponentButton } from '../../shared/ComponentButton';
import {
  loadData,
  putData,
  userAccountUpdated,
} from '../../../utils/ActionCreators';
import utils from '../../../utils/utils';
import { contentType } from '../../../utils/ActionTypes';
import { getAccountDetailsPath } from '../../../utils/routerUtils';
import { fonts } from '../../../utils/fonts';
import { localStorageKey } from '../../../utils/LocalStorage';
import { BASEURL } from '../../../utils/constants';
import { arrowDownAlt } from '../../shared/ComponentIcon';
import {
  getToken,
  updateUserImage,
  updateUserName,
} from '../../../utils/Repository';

const {Panel} = Collapse;
//const getToken = () => localStorage.getItem(localStorageKey.AUTH_TOKEN);

const defaultAvatar = "data:image/png;base64,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";

const props = {
  name: 'avatar_url',
  action: BASEURL+'user/profile/upload',
  headers: {
    Authorization: "Bearer " + getToken(),
  }
};

class UpdateDetails extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      name: prepareInput('name', 'Full Name', true, 'Full Name', '', 'Enter Name',),
      email: prepareInput('email', 'Email Address', true, 'Email Address', '', 'Enter Bundle ID',),
      organization_name: prepareInput('organization_name', 'Organization Name', true, 'Kickback Inc.', '', 'Enter secret',),
      old_password: prepareInput('old_password', 'Old Password', false, '', '', 'Enter Password'),
      new_password: prepareInput('new_password', 'New Password', false, '', '', 'Enter Password'),
      new_password_confirm: prepareInput('new_password_confirm', 'Confirm New Password', false, '', '', 'Enter Password'),
      image_url: defaultAvatar, image_uploading: false, image_name:""
    };
  }

	handleSubmit = e => {
	  const {onPutData} = this.props;

	  e.preventDefault();
	  this.props.form.validateFields((err, values) => {
	    if (values.new_password && values.new_password !== values.new_password_confirm) {
	      this.props.form.setFields({
	        new_password_confirm: {
	          value: values.new_password_confirm,
	          errors: [new Error('Passwords do not match.')],
	        },
	      });
	    }
	    else if (values.old_password && !values.new_password) {
	      this.props.form.setFields({
	        new_password: {
	          value: values.new_password,
	          errors: [new Error('Enter New Password')],
	        },
	      });
	    }
	    else if (!err) {
	      delete values.email;
	      if (!values.old_password)
	        delete values.old_password;
	      if (!values.new_password)
	        delete values.new_password;
	      if (!values.new_password_confirm)
	        delete values.new_password_confirm;
	      if(this.props.data.user.organizations_roles[0].organization_name === values.organization_name){
	      	delete values.organization_name;
		  }

	      this.setState({user_name: values.name, org_name: values.organization_name});
	      onPutData(contentType.ACCOUNT_UPDATE, getAccountDetailsPath, values);
	    }
	  });
	};

	componentDidMount() {

	  if(!this.props.data && this.props.isFetching === false)
	    this.loadList();
	  else if(this.props.data)
	    this.updateFields();
	}

	loadList = () =>{
	  const {onLoadData} = this.props;

	  onLoadData(
	    contentType.ACCOUNT,
	    getAccountDetailsPath,
	  );
	};

	componentDidUpdate (previousProps, prevState, snapshot) {
	  if (this.props.data && previousProps.data !== this.props.data) {
	    this.updateFields();
	  }
	  if (this.props.updateData && previousProps.updateData !== this.props.updateData) {
		  updateUserName(this.state.user_name);
		  this.updateFields();
		  this.props.onUserAccountUpdated(contentType.USER_ACCOUNT_UPDATED, this.state.user_name);
	  }
	}

	updateFields = () => {
	  const data = this.props.data;

	  this.setState({
	    name: prepareInput('name', 'Full Name', true, 'Full Name', '', 'Enter Name', '',this.state.user_name ? this.state.user_name : data.user.name),
	    email: prepareInput('email', 'Email Address', true, 'Email Address', '', 'Enter Email', '', data.user.email),
	    organization_name: prepareInput('organization_name', 'Organization Name', true, 'Kickback Inc.', '', 'Enter Organization Name', '',this.state.org_name ? this.state.org_name: data.user.organizations_roles[0].organization_name),
	    image_url: data.user.avatar_url,
	  });
	};
	onChange = (info) => {
	  if (info.file.status === 'uploading') {
	    this.setState({image_uploading: true});
	  }
	  else if (info.file.status === 'done') {
	    message.success(`${info.file.name} file uploaded successfully`);
	    getBase64(info.file.originFileObj, imageUrl => {

	      updateUserImage(imageUrl);
	      this.props.onUserAccountUpdated(contentType.USER_ACCOUNT_UPDATED, imageUrl);
	      this.setState({
	        image_url: imageUrl,
	        image_uploading: false,
	        image_name:info.file.name
	      });});


	  } else if (info.file.status === 'error') {
	    message.error(`${info.file.name} file upload failed.`);
	  }
	};

	render() {
	  const {isFetching, updateIsFetching} = this.props;
	  return (
	    <div className="account">
	      <Spin spinning={updateIsFetching === true}>
	        <Form onSubmit={this.handleSubmit} layout="vertical">
	          <div className="account-update-form">
	            <ComponentText text="My Details" size="15" font={fonts.SFProDisplaySemiBold} color="var(--dark-sky-blue)" align="left" marginTop="0" marginBottom="30"/>

	            <Skeleton loading={isFetching} active avatar paragraph={{ rows: 0 }} title={null}>
	              <Row type={"flex"} align={"middle"}>
	                <Avatar size={60} src={this.state.image_url} />
	                <Space width="22"/>
	                <Upload {...props}
	                  onChange={this.onChange}
	                  showUploadList={false}>
	                  <Row type={"flex"} style={{width: "100%"}} align={"middle"}>
	                    <Input placeholder="Choose Image" value={this.state.image_name} disabled={true} style={{width:322}}/>
	                    <Button className={"image-upload"} loading={this.state.image_uploading}>{this.state.image_uploading=== true ? "": "Browse"}</Button>
	                  </Row>
	                </Upload>
	              </Row>
	            </Skeleton>
	            <Space height="30"/>

	            <Skeleton loading={isFetching} active paragraph={{ rows: 1 }}>
	              <InputComponent
	                form={this.props.form}
	                layout={formItemLayout}
	                values={this.state.name}
	              />
	            </Skeleton>
	            <Skeleton loading={isFetching} active paragraph={{ rows: 1 }}>
	              <InputComponent
	                disabled = {true}
	                form={this.props.form}
	                layout={formItemLayout}
	                values={this.state.email}
	              />
	            </Skeleton>
	            <Skeleton loading={isFetching} active paragraph={{ rows: 1 }}>
	              <InputComponent
	                form={this.props.form}
	                layout={formItemLayout}
	                values={this.state.organization_name}
	              />
	            </Skeleton>
	          </div>
	          <Collapse
	            bordered={false}
	            defaultActiveKey={['1']}
	            expandIconPosition="right"
	            expandIcon={({isActive}) => <ArrowIcon rotate={isActive ? 90 : 0} style={{marginRight:8, transform: isActive ?"rotate(-90deg)":"rotate(0deg)", WebkitTransform: isActive ?"rotate(-90deg)":"rotate(0deg)", transition: "150ms ease" }}/>}
	          >
	            <Panel header={<ComponentText text="Change Password" size="15" color="var(--water-blue)" font={fonts.SFProDisplaySemiBold}/>}
							   key="3" style={customPanelStyle}>
	              <InputComponent
	                form={this.props.form}
	                layout={formItemLayout}
	                values={this.state.old_password}
	              />
	              <InputComponent
	                form={this.props.form}
	                layout={formItemLayout}
	                values={this.state.new_password}
	              />
	              <InputComponent
	                form={this.props.form}
	                layout={formItemLayout}
	                values={this.state.new_password_confirm}
	              />
	            </Panel>
	          </Collapse>
	          <Form.Item className="no-bottom-margin">
	            <ComponentButton htmlType="submit" name="save" text="Update" css="dark-sky-blue eina-semibold-white-15" width="130" height="42"/>
	          </Form.Item>
	        </Form>
	      </Spin>
	    </div>
	  );
	}
}

const ArrowIcon = props => <Icon component={arrowDownAlt} {...props} />;

const UpdateAccountDetails = Form.create({name: "account-update"})(UpdateDetails);

const mapActionToProps = {
  onLoadData: loadData,
  onPutData: putData,
  onUserAccountUpdated: userAccountUpdated
};

const mapStateToProps = state => {
  const {accountDetailsRemoteData, accountUpdateRemoteData} = state;
  return {
    isFetching: utils.getIsFetching(accountDetailsRemoteData) || utils.getIsFetching(accountUpdateRemoteData),
    data: utils.getItem(accountDetailsRemoteData),
    isFailed: utils.getIsFailed(accountDetailsRemoteData),

    updateData: utils.getItem(accountUpdateRemoteData),
    updateIsFailed: utils.getIsFailed(accountUpdateRemoteData),
  };
};

export default connect(
  mapStateToProps,
  mapActionToProps
)(UpdateAccountDetails);

const formItemLayout = {
  labelCol: {
    xs: {span: 2},
    sm: {span: 2},
  },
  wrapperCol: {
    xs: {span: 2},
    sm: {span: 2},
  },
};

const customPanelStyle = {
  backgroundColor: 'var(--white)',
  borderRadius: 5,
  marginBottom: 20,
  paddingTop: 10,
  paddingBottom: 10,
  border: "solid 1px var(--pale-grey-two)",
  overflow: 'hidden',
};

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
